import {FunctionalComponent, h} from "preact";
import {useEffect} from "preact/hooks";
import {useRef} from "preact/compat";
import {createScript} from "../../libs/ScriptHelper";
import {log} from "../../libs/QuerloLogger";

declare const YT: any;

export const YouTubePlayer: FunctionalComponent<{ msgID: string; videoURL: string; tickCallback: () => void }> = ({msgID, videoURL, tickCallback}) => {

    const playerHolder = useRef(null);

    //autplay, mobile needs to be muted to work,
    // iphone doesn't allow it anyway
    function onReadyPlayer (evt: any) {

/*
        if (!scope.autoplay) return;
        $rootScope.$emit('EVENT_VIDEO_START', scope.id);

        if (window.innerWidth <= 800 && window.innerHeight <= 600) evt.target.mute();
        evt.target.playVideo();
*/
    }

    //callback for the flag wait for completion (needs to be tested)
    function onStateChange (evt: any) {
/*
        if(evt.data === 0) scope.$emit('EVT_VIDEO_END', scope.id);
        if (evt.data === 1) $rootScope.$emit('EVENT_VIDEO_START', scope.id);
*/
    }

    function getID(url: string) {
        return (url.indexOf('?v=') !== -1) ? url.substr(url.indexOf('?v=') + 3) : url.substr(url.lastIndexOf('/') + 1);
    }

    function bootVideo() {
        log.info("Youtube embed script loaded");
        log.info(YT);
        const player = new YT.Player(msgID, {
            height: '100%',
            width: '100%',
            videoId: getID(videoURL),
            host: 'https://www.youtube-nocookie.com',
            playsinline: 1,
            autoplay: 1,
            mute: 1,
            rel: 0,
            modestbranding: 1,
            events: {
                onReady: onReadyPlayer,
                onStateChange: onStateChange
            }
        });
    }

    useEffect(() => {
        // log.info(`use effect for ${msgText}`);
        /** advance queue */
        // tickCallback();
        createScript("//www.youtube.com/iframe_api")
          .then(() => setTimeout(bootVideo, 300));
    }, [msgID]);

    return <div id={msgID} ref={playerHolder} />;
};
